import { FormEvent } from 'react'

import { CONTACT_FORM, STRINGS } from '@/constants/institutionalBuyers'
import useContactUsForm from '@/hooks/useContactUsForm'
import styles from '@/styles/ContactForm.module.css'

import ArrowButton from '../arrowButton'
import Input from '../formFields/Input'
import TextArea from '../formFields/TextArea'

const InstitutionalBuyerContact = () => {
  const { errors, validateFormItem } = useContactUsForm()

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const isFormValid = Array.from(formData.entries()).every(([key, value]) =>
      validateFormItem(key, (value as string) || '')
    )
    if (!isFormValid) {
      event.preventDefault()
      return false
    }
  }

  return (
    <section className="bg-black md:px-[60px] px-4 pt-20 mt-[100px]">
      <h2 className="text-white pb-2.5 font-natosans-medium text-[50px]">
        {STRINGS.INTERESTED_IN_SERVICE}
      </h2>
      <form
        onSubmit={onSubmit}
        action={process.env.NEXT_PUBLIC_INSTITUTIONAL_BUYER_FORM}
        method="POST"
        acceptCharset="UTF-8"
        encType="multipart/form-data"
        className="mt-[30px]"
      >
        <input
          type="hidden"
          name="zf_redirect_url"
          value="https://agrevolution.in/solution-for-institutional-buyers"
          className="hidden"
        />
        <Input
          label={CONTACT_FORM.ENTER_NAME_LABEL}
          id="name"
          name="SingleLine"
          placeholder={CONTACT_FORM.ENTER_NAME_PLACEHOLDER}
          errorMessage={errors.name}
        />
        <Input
          label={CONTACT_FORM.ENTER_EMAIL_LABEL}
          id="email"
          name="Email"
          placeholder={CONTACT_FORM.ENTER_EMAIL_PLACEHOLDER}
          type="email"
          errorMessage={errors.email}
        />
        <Input
          label={CONTACT_FORM.PHONE_NUMBER_LABEL}
          id="phoneNumber"
          name="PhoneNumber_countrycode"
          placeholder={CONTACT_FORM.PHONE_NUMBER_PLACEHOLDER}
          type="number"
          errorMessage={errors.phoneNumber}
        />
        <TextArea
          id="message"
          label={CONTACT_FORM.ENTER_MESSAGE_LABEL}
          placeholder={CONTACT_FORM.ENTER_MESSAGE_PLACEHOLDER}
          errorMessage={errors.message}
          name="MultiLine"
          rows={8}
        />
        <div
          className={`relative mb-2 group w-32 ${styles.submitContainer} pb-8`}
        >
          <span
            className={`group-hover:bg-[#6fbc1d] group-hover:w-full absolute top-0 left-0 h-8 ${styles.slider}`}
          />
          <ArrowButton label="SUBMIT" btnType="submit" />
        </div>
      </form>
    </section>
  )
}

export default InstitutionalBuyerContact
